import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const FeatureCardSkeleton = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-sm)',
      padding: 'var(--space-lg)',
      borderRadius: 'var(--radius-lg)',
      border: '1px solid var(--color-border)',
      background: 'var(--color-surface)',
    }}
  >
    <SkeletonCircle size={48} />
    <SkeletonText widths={['70%']} lineHeight="20px" />
    <SkeletonText widths={['100%', '90%', '70%']} lineHeight="14px" />
  </div>
);

const PublicHomeSkeleton = () => (
  <div aria-hidden="true" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2xl)' }}>
    {/* Top nav strip */}
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'var(--space-md) clamp(1rem, 4vw, 3rem)',
        borderBottom: '1px solid var(--color-border-subtle)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
        <SkeletonCircle size={32} />
        <SkeletonText widths={['96px']} lineHeight="20px" />
      </div>
      <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
        <SkeletonBox width={80} height={36} borderRadius="999px" />
        <SkeletonBox width={104} height={36} borderRadius="999px" />
      </div>
    </div>

    {/* Hero */}
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-md)',
        alignItems: 'center',
        textAlign: 'center',
        padding: 'clamp(2rem, 6vw, 4rem) clamp(1rem, 4vw, 3rem) 0',
      }}
    >
      <SkeletonBox width={120} height={28} borderRadius="999px" />
      <SkeletonText widths={['min(620px, 88vw)']} lineHeight="56px" />
      <SkeletonText widths={['min(420px, 70vw)']} lineHeight="20px" />
      <div style={{ display: 'flex', gap: 'var(--space-md)', marginTop: 'var(--space-sm)' }}>
        <SkeletonBox height={48} width={160} borderRadius="999px" />
        <SkeletonBox height={48} width={140} borderRadius="999px" />
      </div>
    </div>

    {/* Hero visual */}
    <SkeletonBox
      height={360}
      borderRadius="var(--radius-lg)"
      style={{ margin: '0 clamp(1rem, 4vw, 3rem)', maxWidth: '1080px', width: 'auto' }}
    />

    {/* Feature grid */}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: 'var(--space-lg)',
        padding: '0 clamp(1rem, 4vw, 3rem)',
      }}
    >
      <FeatureCardSkeleton />
      <FeatureCardSkeleton />
      <FeatureCardSkeleton />
    </div>

    {/* CTA strip */}
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--space-md)',
        padding: 'clamp(2rem, 5vw, 3rem) clamp(1rem, 4vw, 3rem)',
        borderRadius: 'var(--radius-lg)',
        background: 'var(--color-surface-subtle)',
        margin: '0 clamp(1rem, 4vw, 3rem) clamp(2rem, 5vw, 3rem)',
      }}
    >
      <SkeletonText widths={['min(420px, 80vw)']} lineHeight="32px" />
      <SkeletonText widths={['min(320px, 70vw)']} lineHeight="16px" />
      <SkeletonBox width={200} height={48} borderRadius="999px" />
    </div>
  </div>
);

export default PublicHomeSkeleton;
